import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Settings, Play, Volume2, VolumeX } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function HomePage() {
  const navigate = useNavigate();
  const [soundEnabled, setSoundEnabled] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const handlePlayClick = () => {
    navigate("/category");
  };

  const handleAdminClick = () => {
    navigate("/admin");
  };

  return (
    <div className="studio-background min-h-screen flex flex-col items-center justify-center p-4">
      {/* Background Effects */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-neon-cyan/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-studio-light/10 rounded-full blur-3xl"></div>
      </div>

      {/* Logo */}
      <div className="relative z-10 mb-8 animate-fade-in-up">
        <div className="relative">
          {/* Outer glow ring */}
          <div className="absolute inset-0 rounded-full bg-gradient-to-r from-neon-cyan/30 to-neon-gold/30 blur-xl scale-110"></div>
          
          {/* Main logo container */}
          <div className="relative w-64 h-64 md:w-80 md:h-80 rounded-full bg-gradient-to-b from-studio-light to-studio border-4 border-white/80 shadow-neon-cyan flex items-center justify-center">
            <div className="text-center p-6">
              <h1 className="font-heading text-3xl md:text-4xl text-neon-gold mb-2 drop-shadow-lg">
                من سيربح
              </h1>
              <div className="w-full h-1 bg-gradient-to-r from-transparent via-neon-gold to-transparent my-2"></div>
              <h1 className="font-heading text-4xl md:text-5xl text-white drop-shadow-lg">
                المليون
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Subtitle */}
      <p className="text-white/80 font-body text-lg md:text-xl mb-12 text-center animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
        هل أنت مستعد للتحدي؟
      </p>

      {/* Buttons */}
      <div className="flex flex-col gap-4 w-full max-w-xs animate-fade-in-up" style={{ animationDelay: '0.4s' }}>
        <Button
          data-testid="play-button"
          onClick={handlePlayClick}
          disabled={isLoading}
          className="w-full py-6 text-xl font-heading bg-gradient-to-r from-neon-gold to-neon-gold-dim hover:from-neon-gold-dim hover:to-neon-gold text-studio border-2 border-white/50 rounded-full shadow-neon-gold transition-all duration-300 hover:scale-105 hover:shadow-[0_0_30px_rgba(255,215,0,0.6)]"
        >
          <Play className="ml-2 w-6 h-6" />
          ابدأ اللعب
        </Button>

        <Button
          data-testid="admin-button"
          onClick={handleAdminClick}
          variant="outline"
          className="w-full py-5 text-lg font-body bg-transparent hover:bg-white/10 text-white border-2 border-white/50 rounded-full transition-all duration-300 hover:border-neon-cyan hover:shadow-neon-cyan"
        >
          <Settings className="ml-2 w-5 h-5" />
          لوحة التحكم
        </Button>
      </div>

      {/* Prize Info */}
      <div className="mt-12 text-center animate-fade-in-up" style={{ animationDelay: '0.6s' }}>
        <p className="text-white/60 font-body text-sm mb-2">الجائزة الكبرى</p>
        <p className="font-numbers text-4xl md:text-5xl text-neon-gold font-bold drop-shadow-lg">
          1,000,000
        </p>
        <p className="text-white/60 font-body text-sm mt-1">ريال</p>
      </div>

      {/* Sound Toggle */}
      <button
        data-testid="sound-toggle"
        onClick={() => setSoundEnabled(!soundEnabled)}
        className="fixed bottom-6 left-6 p-3 rounded-full bg-studio-light/50 border border-white/30 text-white hover:bg-studio-light transition-all duration-300 hover:border-neon-cyan"
      >
        {soundEnabled ? <Volume2 className="w-5 h-5" /> : <VolumeX className="w-5 h-5" />}
      </button>

      {/* Version */}
      <p className="absolute bottom-4 right-4 text-white/30 text-xs font-body">
        الإصدار 1.0
      </p>
    </div>
  );
}
